export const hasStatus = (error: unknown): error is { status: unknown } =>
  typeof error === 'object' && error !== null && 'status' in error

export function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message
  return String(error)
}
